import "./filtros.css";
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Label, Boton } from "asocomponents"
import { addFiltrosLiquidaciones, setFiltrosCargados } from '../../../redux/filtroLiquidacionesSlice'
import BuscadorJuicios from "../Buscadores/BuscadorJuicios/BuscadorJuicios";

export default function FiltrosLiquidaciones() {
  const dispatch = useDispatch()
  const filtrosCargados = useSelector(state => state.rootReducer.filtroLiquidaciones)
  const usuarioString = sessionStorage.getItem('usuario') ? JSON.parse(sessionStorage.getItem('usuario')) : null;

  const [caratula, setCaratula] = useState()
  const [nroSiniestro, setNroSiniestro] = useState()
  const [expediente, setExpediente] = useState()
  const [idJuicio, setIdJuicio] = useState();
  const [cuitLetrado, setCuitLetrado] = useState(usuarioString?.usuario)

  const handleFiltros = () => {
    const filtros = {
      caratula: caratula,
      nroSiniestro: nroSiniestro,
      expediente: expediente,
      idJuicio: idJuicio
    }

    dispatch(addFiltrosLiquidaciones(filtros))
    dispatch(setFiltrosCargados(!filtrosCargados))
  }
  const handleIdJuicio = (juicio) => {
    setIdJuicio(juicio.idJuicio)
  }

  useEffect(() => {
    handleFiltros()
  }, [])

  return (
    <div className="flex flex-row justify-start items-center w-[98%]">
      <Label texto="IdJuicio: " size="text-m" />
      <BuscadorJuicios onChange={handleIdJuicio} width="w-20" cuitLetrado={cuitLetrado} referente="administrativo" />
      <Boton icono="buscar" onClick={handleFiltros} alt="Buscar" height="h-8" />
    </div>
  )
}
